import React, { Component } from 'react'
import Firebase from '../Firebase';
import { Table } from 'react-bootstrap';
import Qestions from './Questions.json';
import { confirmAlert } from 'react-confirm-alert'; // Import
export class SsrIndex extends Component {
    constructor(props) {
        super(props)

    }
    render() {
        return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div className="data_center">
                    <p style={{ textAlign: 'center', fontSize: 26 }}>
                        <strong>
                            แบบสอบถาม
                        <br></br>
                        ประเมินผลโครงการการพัฒนาพื้นที่ครอบครัวอบอุ่นต้นแบบ
                        <br></br>
                        ที่เชื่อมโยงและบูรณาการกับระบบและกลไกการดูแลระดับพื้นที่
                    </strong>
                    </p>
                    <br></br>
                    <hr></hr>
                    <Data></Data>
                    <div>
                        <p>ติดต่อผู้พัฒนา email:adison.ra.56@ubu.ac.th  line-ID:oqiew2537</p>
                        <p>โทรศัพท์:0933807540 นายอดิศร ราชชิต</p>
                    </div>
                </div>
            </div>
        )
    }
}

export default SsrIndex


class Data extends Component {
    constructor(props) {
        super(props)
        this.state = {
            step: 0,
            // personal data
            Sex: '',
            Age: '',
            Role: '',
            Role_another: false,
            Answer: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],//22

            tQestions1: [],
            tQestions2: [],
            tQestions3: [],
            tQestions41: [],
            tQestions42: [],
            Suggestion: '',
            textscore: ['1', '2', '3', '4', '5']

        }
    }
    ans(id, value) {
        let Answer = this.state.Answer;
        Answer[id] = value;
        console.log(id, '=', value);
        this.setState({
            Answer
        })

    }
    componentDidMount() {
        const textscore = this.state.textscore;
        // const school1 = [];
        const tQestions1 = [];
        const tQestions2 = [];
        const tQestions3 = [];
        const tQestions41 = [];
        const tQestions42 = [];
        let index = 0;
        Qestions.Q1.forEach((doc, i) => {

            if (i === 0) {
                doc.question.forEach((doc2, i2) => {
                    tQestions1.push(
                        <tr key={index}>
                            <td>
                                {(i + 1) + "." + (i2 + 1)}
                            </td>
                            <td>
                                {doc2}
                            </td>
                            <td >
                                <input required type="radio" name={(i + 1) + "." + (i2 + 1)} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[0])} />
                            </td>
                            <td>
                                <input type="radio" name={(i + 1) + "." + (i2 + 1)} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[1])} />
                            </td>
                            <td>
                                <input type="radio" name={(i + 1) + "." + (i2 + 1)} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[2])} />
                            </td>
                            <td>
                                <input type="radio" name={(i + 1) + "." + (i2 + 1)} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[3])} />
                            </td>
                            <td>
                                <input type="radio" name={(i + 1) + "." + (i2 + 1)} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[4])} />
                            </td>

                        </tr>
                    )
                    index++;
                })
            } else if (i === 1) {
                doc.question.forEach((doc2, i2) => {
                    tQestions2.push(
                        <tr key={index}>
                            <td>
                                {(i + 1) + "." + (i2 + 1)}
                            </td>
                            <td>
                                {doc2}
                            </td>
                            <td>
                                <input required type="radio" name={(i + 1) + "." + (i2 + 1)} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[0])} />
                            </td>
                            <td>
                                <input type="radio" name={(i + 1) + "." + (i2 + 1)} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[1])} />
                            </td>
                            <td>
                                <input type="radio" name={(i + 1) + "." + (i2 + 1)} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[2])} />
                            </td>
                            <td>
                                <input type="radio" name={(i + 1) + "." + (i2 + 1)} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[3])} />
                            </td>
                            <td>
                                <input type="radio" name={(i + 1) + "." + (i2 + 1)} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[4])} />
                            </td>

                        </tr>
                    )
                    index++;
                })
            } else if (i === 2) {
                doc.question.forEach((doc2, i2) => {
                    tQestions3.push(
                        <tr key={index}>
                            <td>
                                {(i + 1) + "." + (i2 + 1)}
                            </td>
                            <td>
                                {doc2}
                            </td>
                            <td>
                                <input required type="radio" name={(i + 1) + "." + (i2 + 1)} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[0])} />
                            </td>
                            <td>
                                <input type="radio" name={(i + 1) + "." + (i2 + 1)} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[1])} />
                            </td>
                            <td>
                                <input type="radio" name={(i + 1) + "." + (i2 + 1)} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[2])} />
                            </td>
                            <td>
                                <input type="radio" name={(i + 1) + "." + (i2 + 1)} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[3])} />
                            </td>
                            <td>
                                <input type="radio" name={(i + 1) + "." + (i2 + 1)} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[4])} />
                            </td>

                        </tr>
                    )
                    index++;
                })
            } else if (i === 3) {
                doc.question.forEach((doc2, i2) => {

                    if (i2 === 0) {
                        doc2.subq.forEach((doc3, i3) => {
                            tQestions41.push(
                                <tr key={index}>
                                    <td>
                                        {(i + 1) + "." + (i3 + 1)}
                                    </td>
                                    <td>
                                        {doc3}
                                    </td>
                                    <td>
                                        <input required type="radio" name={(i + 1) + "." + (i3 + 1)} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[0])} />
                                    </td>
                                    <td>
                                        <input type="radio" name={(i + 1) + "." + (i3 + 1)} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[1])} />
                                    </td>
                                    <td>
                                        <input type="radio" name={(i + 1) + "." + (i3 + 1)} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[2])} />
                                    </td>
                                    <td>
                                        <input type="radio" name={(i + 1) + "." + (i3 + 1)} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[3])} />
                                    </td>
                                    <td>
                                        <input type="radio" name={(i + 1) + "." + (i3 + 1)} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[4])} />
                                    </td>

                                </tr>
                            )
                            index++;
                        })
                    } else if (i2 === 1) {
                        doc2.subq.forEach((doc3, i3) => {

                            tQestions42.push(
                                <tr key={index}>
                                    <td>
                                        {(i + 1) + "." + (i3 + 4)}
                                    </td>
                                    <td>
                                        {doc3}
                                    </td>
                                    <td>
                                        <input required type="radio" name={(i + 1) + "." + (i3 + 1) + "2"} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[0])} />
                                    </td>
                                    <td>
                                        <input type="radio" name={(i + 1) + "." + (i3 + 1) + "2"} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[1])} />
                                    </td>
                                    <td>
                                        <input type="radio" name={(i + 1) + "." + (i3 + 1) + "2"} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[2])} />
                                    </td>
                                    <td>
                                        <input type="radio" name={(i + 1) + "." + (i3 + 1) + "2"} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[3])} />
                                    </td>
                                    <td>
                                        <input type="radio" name={(i + 1) + "." + (i3 + 1) + "2"} style={{ margin: 5 }} onChange={this.ans.bind(this, index, textscore[4])} />
                                    </td>

                                </tr>
                            )
                            index++;

                        })
                    }
                })
            }

        })
        this.setState({
            tQestions1,
            tQestions2,
            tQestions3,
            tQestions41,
            tQestions42

        })
    }
    onChange = (e) => {
        const state = this.state
        state[e.target.name] = e.target.value;
        console.log(e.target.name + " == " + e.target.value);
        this.setState(state);

    }
    onSubmitStep1 = (e) => {
        e.preventDefault();
        const { Sex, Age, Role } = this.state;
        console.log(Sex, Age, Role)
        this.setState({
            step: 2
        })


    }
    onSubmitStep2 = (e) => {
        e.preventDefault();
        let Score_temp1 = 0;
        const { Answer, Sex, Age, Role, Suggestion } = this.state;
        const Create_date = new Date();
        Firebase.firestore().collection('SSUREE').add({
            Answer, Sex, Age, Role, Create_date, Suggestion
        }).then((doc) => {
            console.log('success');
            confirmAlert({
                title: 'บันทึกสำเร็จ',
                message: ' ขอบคุณที่สละเวลาตอบแบบสอบถาม',
                closeOnClickOutside: true,
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => this.setState({
                            reset_password: false,
                            login: true,

                        })
                    },

                ]
            });
            this.setState({
                step: 0,
                // personal data
                Sex: '',
                Age: '',
                Role: '',
                Role_another: false,
                Answer: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],//22

                tQestions1: [],
                tQestions2: [],
                tQestions3: [],
                tQestions41: [],
                tQestions42: [],
                Suggestion: '',
            })
        }).catch((error) => {
            console.log(error, 'error');
        })

    }
    render() {
        if (this.state.step === 0) {
            return (
                <div>
                    <div style={{ margin: '3%' }}>
                        <p style={{ textDecoration: 'underline', fontSize: 20 }}>
                            คำชี้แจง
                        </p>

                        <p style={{ fontSize: 18, lineHeight: 2, }}>
                            <span style={{ marginLeft: '3%', marginRight: '3%' }}> </span>
                            เครื่องมือในการติดตามและประเมินผลโครงการการพัฒนาพื้นที่ครอบครัวอบอุ่นต้นแบบที่เชื่อมโยงและบูรณาการกับระบบและกลไกการดูแลระดับพื้นที่
                             มีวัตถุประสงค์เพื่อประเมินผลการดำเนินงานในระดับพื้นที่ในประเด็นผลผลิต
                              ผลลัพธ์ผลกระทบที่เกิดขึ้นจากการจัดทํานวัตกรรมในแต่ละพื้นที่ประเมินระบบกลไกที่เกิดขึ้นในระดับหมู่บ้าน
                               และองค์กร ประกอบด้วยระบบกลไกของกลุ่มสตรี อาสาสมัครครอบครัว
                                ศูนย์พัฒนาครอบครัว วัด โรงเรียน โรงพยาบาลส่งเสริมสุขภาพตำบล
                                 สภาเด็กและเยาวชนกลไกคณะอนุกรรมการด้านครอบครัวตำบลศรีไค
                                  ทั้งนี้ มีการติดตามและประเมินผลการดำเนินโครงการการพัฒนาพื้นที่ครอบครัวอบอุ่นต้นแบบที่เชื่อมโยงและบูรณาการกับระบบและกลไกการดูแลระดับพื้นที่
                                   โดยแบบสอบถามแบ่งออกเป็น 3 ส่วนดังนี้
                            <br></br>
                            <strong>ส่วนที่ 1 </strong>ข้อมูลทั่วไปของผู้ตอบแบบสอบถาม<br></br>
                            <strong>ส่วนที่ 2 </strong>การประเมินผลการดำเนินโครงการการพัฒนาพื้นที่ครอบครัวอบอุ่นต้นแบบที่เชื่อมโยงและบูรณาการกับระบบและกลไกการดูแลระดับพื้นที่<br></br>
                            <span style={{ marginLeft: '3%' }}></span>2.1 ด้านสภาพแวดล้อมของโครงการ<br></br>
                            <span style={{ marginLeft: '3%' }}></span>2.2 ด้านความพอเพียงของทรัพยากรที่ใช้ในการดำเนินกิจกรรม<br></br>
                            <span style={{ marginLeft: '3%' }}></span>2.3 ด้านความเหมาะสมของกระบวนการจัดกิจกรรม/โครงการ<br></br>
                            <span style={{ marginLeft: '3%' }}></span>2.4 ด้านความสำเร็จตามวัตถุประสงค์และเป้าหมายในการจัดกิจกรรม<br></br>
                            <strong>ส่วนที่ 3 </strong>ข้อเสนอแนะ<br></br>
                            <span style={{ marginLeft: '3%' }}> </span>
                            ทั้งนี้ เพื่อให้ผลการศึกษาสามารถสะท้อนความเป็นจริงตามความความคิดเห็นของท่านได้เป็นอย่างดี
                            ท่านสามารถแสดงความคิดเห็นได้อย่างเป็นอิสระและขอยืนยันว่าข้อมูลส่วนบุคคลและคำตอบของท่านจะถูกเก็บไว้เป็นความลับและไม่ถูกนำไปเผยแพร่หรือใช้เพื่อการใด ๆ ทั้งสิ้น
                        </p>

                    </div>
                    <div style={{ justifyContent: 'center', display: 'flex', marginBottom: 100 }}>
                        <button type="submit" onClick={() => { this.setState({ step: 1 }) }} style={{ padding: 10, borderRadius: 10, backgroundColor: '#00ff80', fontSize: 20, color: '#ffffff' }}>เริ่มทำแบบสอบถาม</button>
                    </div>
                </div>
            )
        } else if (this.state.step === 1) {
            return (
                <form onSubmit={this.onSubmitStep1}>

                    <p><strong className="titie3" style={{ backgroundColor: '#ffc1a4', padding: 5 }}>ส่วนที่ 1 : ข้อมูลทั่วไปของผู้ตอบแบบสอบถาม</strong></p>
                    <div style={{ marginLeft: '3%', marginRight: '3%' }}>
                        <div className="input-form">
                            <label>1. เพศ: <label style={{ color: "red" }}>*</label></label>
                            <div style={{ marginLeft: 20 }}>
                                <div>
                                    <input required type="radio" name="Sex" value="ชาย" style={{ maring: 5 }} onChange={this.onChange} />ชาย
                                            </div>
                                <div>
                                    <input type="radio" name="Sex" value="หญิง" style={{ maring: 5 }} onChange={this.onChange} />หญิง
                                            </div>

                            </div>
                        </div>
                        <div className="input-form">
                            <label>2. อายุ: <label style={{ color: "red" }}>*</label></label>
                            <div style={{ marginLeft: 20 }}>
                                <div>
                                    <input required type="radio" name="Age" value="ต่ำกว่า 20 ปี" style={{ margin: 5 }} onChange={this.onChange} />ต่ำกว่า 20 ปี
                                            </div>
                                <div>
                                    <input type="radio" name="Age" value="20-30 ปี" style={{ margin: 5 }} onChange={this.onChange} />20-30 ปี
                                            </div>
                                <div>
                                    <input type="radio" name="Age" value="31-40 ปี" style={{ margin: 5 }} onChange={this.onChange} />31-40 ปี
                                            </div>
                                <div>
                                    <input type="radio" name="Age" value="41-50 ปี" style={{ margin: 5 }} onChange={this.onChange} />41-50 ปี
                                             </div>
                                <div>
                                    <input type="radio" name="Age" value="51 ปีขึ้นไป" style={{ margin: 5 }} onChange={this.onChange} />51 ปีขึ้นไป
                                             </div>
                            </div>
                        </div>
                        <div className="input-form">
                            <label>3. บทบาทในการดำเนินโครงการของผู้ตอบแบบสอบถาม: <label style={{ color: "red" }}>*</label></label>
                            <div style={{ marginLeft: 20 }}>
                                <div>
                                    <input required type="radio" name="Role" value="ผู้เข้าร่วมโครงการ" style={{ margin: 5 }} onChange={(e) => this.setState({ Role: e.target.value, Role_another: false })} />ผู้เข้าร่วมโครงการ
                                            </div>
                                <div>
                                    <input type="radio" name="Role" value="แกนนำโครงการ" style={{ margin: 5 }} onChange={(e) => this.setState({ Role: e.target.value, Role_another: false })} />แกนนำโครงการ
                                            </div>
                                <div>
                                    <input type="radio" name="Role" value="อื่น ๆ" style={{ margin: 5 }} onChange={() => this.setState({ Role_another: true })} />อื่น ๆ (ระบุ).............................................
                                            </div>
                                {this.state.Role_another &&

                                    <div>
                                        <input required placeholder="อื่น ๆ (ระบุ)" style={{ width: '50%', height: 35, borderRadius: 10 }} onChange={(e) => this.setState({ Role: e.target.value })}></input>
                                    </div>}
                            </div>
                        </div>

                    </div>
                    {/* 1 */}
                    <div style={{ justifyContent: 'center', display: 'flex', marginBottom: 100 }}>
                        <button type="submit" style={{ padding: 10, borderRadius: 10, backgroundColor: '#00ff80', fontSize: 20 }}>ถัดไป</button>
                    </div>
                </form>
            )
        } else if (this.state.step === 2) {
            return (
                <form onSubmit={this.onSubmitStep2}>

                    {/*    2 */}
                    <p><strong className="titie3">ส่วนที่ 2 : การประเมินผลการดำเนินโครงการการพัฒนาพื้นที่ครอบครัวอบอุ่นต้นแบบที่เชื่อมโยงและบูรณาการกับระบบและกลไกการดูแลระดับพื้นที่ </strong></p>
                    <div style={{ marginLeft: '3%', marginRight: '3%' }}>
                        <p><strong style={{ textDecoration: 'underline' }}>คำชี้แจง </strong> โปรดทำเครื่องหมาย (√) ในช่องที่ตรงกับความเห็นท่าน</p>
                        <hr></hr>
                        <Table striped bordered hover size="sm" style={{ width: '100%' }}>
                            <thead>
                                <tr>
                                    <th rowSpan="2" style={{ verticalAlign: 'top' }}>ข้อ</th>
                                    <th rowSpan="2" style={{ verticalAlign: 'top', textAlign: 'center' }}>ประเมินผลกิจกรรม</th>
                                    <th colSpan="5">ระดับ</th>
                                </tr>
                                <tr>
                                    <th style={{ textAlign: 'center' }}>1</th>
                                    <th style={{ textAlign: 'center' }}>2</th>
                                    <th style={{ textAlign: 'center' }}>3</th>
                                    <th style={{ textAlign: 'center' }}>4</th>
                                    <th style={{ textAlign: 'center' }}>5</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr key={101}>

                                    <td colSpan={7} style={{ backgroundColor: '#aaffff' }}><strong>1. ด้านสภาพแวดล้อมของโครงการ </strong></td>

                                </tr>

                                {this.state.tQestions1}
                                <tr key={102}>
                                    <td colSpan={7} style={{ backgroundColor: '#aaffff' }}><strong>2. ด้านความพอเพียงของทรัพยากรที่ใช้ในการดำเนินกิจกรรม</strong></td>

                                </tr>
                                {this.state.tQestions2}
                                <tr key={103}>
                                    <td colSpan={7} style={{ backgroundColor: '#aaffff' }}><strong>3. ด้านความเหมาะสมของกระบวนการจัดกิจกรรม/โครงการ</strong></td>

                                </tr>
                                {this.state.tQestions3}
                                <tr key={104}>
                                    <td colSpan={7} style={{ backgroundColor: '#aaffff' }}><strong>4. ด้านความเหมาะสมของกระบวนการจัดกิจกรรม/โครงการ</strong></td>
                                </tr>
                                <tr>
                                    <td colSpan={7} >ด้านผลผลิต (Output)</td>

                                </tr>
                                {this.state.tQestions41}
                                <tr key={105}>
                                    <td colSpan={7} >ด้านผลลัพธ์ (Outcome)</td>

                                </tr>
                                {this.state.tQestions42}

                            </tbody>
                        </Table>
                        <p>ข้อเสนอแนะ</p>
                        <textarea rows="4" style={{ borderRadius: 10, width: '80%', marginLeft: '3%' }}
                            onChange={str => this.setState({ Suggestion: str.target.value })}></textarea>
                        <br></br>

                    </div>

                    <div style={{ justifyContent: 'center', display: 'flex', marginBottom: 100 }}>
                        <button type="submit" style={{ padding: 10, borderRadius: 10, backgroundColor: '#00ff80', fontSize: 20 }}>ส่งคำตอบ</button>
                    </div>
                </form>
            )
        }
        else {
            return (
                <div></div>
            )
        }
    }
}